export default "/storefront/client/images/enJoy_nuskinrewards_white1.png";